import React from "react";
import {injectIntl} from "react-intl";
import MsFeedbackMessage from "./ms-feedback-message.jsx";

class MSTimer extends React.PureComponent {
  constructor(props) {
    super(props);

    let now = Math.floor((new Date()).getTime() / 1000);
    this.timer = 0;
    this.state = {
      seconds: this.props.goLive - now,
      time: {}
    };
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  secondsToTime(secs) {
    let days = (secs < 0) ? 0 : Math.floor(secs / ( 60 * 60 * 24));
    let hours = (secs < 0) ? 0 : Math.floor((secs % ( 60 * 60 * 24)) / ( 60 * 60));
    let minutes = (secs < 0) ? 0 : Math.floor((secs % ( 60 * 60)) / ( 60));
    let seconds = (secs < 0) ? 0 : Math.floor((secs % ( 60)) );

    return {
      "d": days,
      "h": hours,
      "m": minutes,
      "s": seconds
    };
  }

  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
    this.startTimer();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startTimer() {
    if (this.timer == 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds == 0) {
      clearInterval(this.timer);
    }
  }

  static formatDate(goLive,timeZone) {
    let monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    let date = new Date(goLive * 1000);

    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    if(!timeZone){
    let timezone = "";
    let timezoneRegx = date.toString().match(/\((.*)\)/);
    if (timezoneRegx && timezoneRegx.length > 0 ){
      timezone = timezoneRegx[1].replace(/[^A-Z]/g, '');
    }
      return monthNames[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear() +
        " - " +  hours + ':' + minutes + ' ' + ampm + ' ' + timezone;
    }else{
      return date.toLocaleString(
          'en-US', {
            timeZone: timeZone,
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZoneName: "short" });
    }





  }

  renderCountdownUnit(value, label) {
    return (
      <div className="countdown-unit" key={label}>
        <span className="countdown-value">{value}</span>
        <span className="countdown-label">{label}</span>
      </div>
    );
  }

  render() {
    let expired = (Date.now() - (this.props.goLive * 1000)) > 36*3600000;
    let subTitle = expired ? "This stream has expired." : "Is Scheduled to go live at";
    let countDownComponent = null;
    if (!expired) {
      const { d, h, m, s } = this.state.time;
      countDownComponent = (
        <div className="countdown_emb" id="countdown_emb" aria-live="polite">
          {this.renderCountdownUnit(d, "days")}
          {this.renderCountdownUnit(h, "hrs")}
          {this.renderCountdownUnit(m, "mins")}
          {this.renderCountdownUnit(s, "secs")}
        </div>
      );
    }
    let message = MSTimer.formatDate(this.props.goLive, this.props.timeZone);

    return (
        <MsFeedbackMessage
          title={this.props.title}
          message={message}
          wclass="unavailable scheduled-live"
          eyebrow={expired ? null : "Upcoming"}
          subTitle={subTitle}
          bottomComponent={countDownComponent}
        />
    )
  }
}
export default injectIntl(MSTimer);
